export const environment = {
  production: true,
  BASE_API_URL_WEBRIFIUTI: 'https://www.webrifiuti.it/api/',
  BASE_API_URL_APIREST: 'https://www.webrifiuti.it/apirest/',
  SOCKET_ENDPOINT_RICICLATV: 'https://socket.hichat.it:8500/?token=',
  SOCKET_TOKEN_RICICLATV: '',
  BANNER_IMAGE_URL_RICICLATV: 'https://www.ricicla.tv/dev/laravel_app/storage/app/images/riciclatv/banner_bottom/',
  START_YEAR: 2020,
  //  BASE_API_URL     :'http://rentrincloud.it:8080/api/',
  //  BASE_PUBLIC_IMAGE:"http://rentrincloud.it:8080/api/public/imguser/"
  BASE_URL_HELP: 'https://rentrincloud.it/dochelp/',
  BASE_API_URL: 'https://rentrincloud.it/api/',
  BASE_PUBLIC_IMAGE: "https://rentrincloud.it/api/public/imguser/",
  PRECISION: ',##0.000',
  LINK_HOME_PAGE: 'https://www.winwaste.net/ww',
  SHOW_RENTRI: false,
  TIME_SESSION: 18, // espressa in minuti e indica il tempo per avviso di sessione che sta per scadere
  MAX_VALUE_PESO: '99999.999', // espressa in KG
  MIN_VALUE_PESO: '1.000', // espressa in KG

  ALL_CHARACTERS: '/[a-zA-Z0-9,.\\-+èù*\\\/()$%&?:;_#{}@àù<>ì&^ ]/',
  GENERIC_STRING: '/[a-zA-Z0-9,.\\-+*\\\/()$%&?:;_#{}@<>& ]/',
  ONLY_NUMBER_CHARACTERS: '/[0-9]/',
  ONLY_CHARACTERS: '/[a-zA-z0-9 ]/',
  CHARACTERS_DATE: '/[0-9\\\/]/',
  CHARACTERS_NUMBER_INPUT: '/[0-9]/'

};


